// BRANDS — one profile per brand we sell. NO imports: scripts/prerender.js
// loads this file by stripping import/export and evaluating it.
//
// Every product gets a brand and a type through brandOf() / typeOf(). Today's
// Daikin entries in catalogue.js carry neither, so they default to Daikin and
// split. A new product must set `brand` and `type` ("split" or "window").
//
// A null value means "we do not have this fact". The compare tool shows
// "Not given by brand" for it, and hides the row when every AC lacks it.
// Never fill a null with a guess.

export const BRANDS = {
  Daikin: {
    name: 'Daikin',
    short: 'Daikin',
    logo: null,
    // From ProductDetail.jsx: inverter 1 year unit, 5 years PCB, 10 years
    // compressor. Fixed speed: 1 year unit, 5 years compressor.
    warranty: {
      split: {
        inverter: { unit: 1, pcb: 5, compressor: 10 },
        fixed: { unit: 1, pcb: null, compressor: 5 },
      },
      window: null,
    },
    // From our own service experience, after the warranty ends.
    repair: {
      split: {
        inverter: 'Control board (PCB) repair is about ₹3,500. A new PCB costs much more.',
        fixed: 'Very sturdy, few breakdowns. A capacitor is about ₹1,500.',
      },
      window: null,
    },
  },
  'O-General': {
    name: 'O-General',
    short: 'O-General',
    logo: null,
    warranty: { split: null, window: null },
    repair: { split: null, window: null },
  },
  'Mitsubishi Heavy Industries': {
    name: 'Mitsubishi Heavy Industries',
    short: 'Mitsubishi Heavy',
    logo: null,
    warranty: { split: null, window: null },
    repair: { split: null, window: null },
  },
  Hitachi: {
    name: 'Hitachi',
    short: 'Hitachi',
    logo: null,
    warranty: { split: null, window: null },
    repair: { split: null, window: null },
  },
};

export const AC_TYPES = ['split', 'window'];

export const brandOf = (model) => model.brand || 'Daikin';
export const typeOf = (model) => model.type || 'split';
export const brandProfile = (model) => BRANDS[brandOf(model)] || null;

const speedKey = (model) => (model.inverter ? 'inverter' : 'fixed');

// { unit, pcb, compressor } in years, or null when the brand has not told us.
export function warrantyFor(model) {
  const p = brandProfile(model);
  const byType = p && p.warranty ? p.warranty[typeOf(model)] : null;
  return byType ? byType[speedKey(model)] || null : null;
}

export function warrantyText(w) {
  if (!w) return null;
  const parts = [];
  if (w.unit != null) parts.push(`${w.unit} year${w.unit === 1 ? '' : 's'} on the whole unit`);
  if (w.pcb != null) parts.push(`${w.pcb} years on the control board (PCB)`);
  if (w.compressor != null) parts.push(`${w.compressor} years on the compressor`);
  return parts.join(' · ');
}

// Plain text, or null when the brand profile has nothing for this type.
export function repairFor(model) {
  const p = brandProfile(model);
  const byType = p && p.repair ? p.repair[typeOf(model)] : null;
  return byType ? byType[speedKey(model)] || null : null;
}

export const typeLabel = (type) => (type === 'window' ? 'Window AC' : 'Split AC');
